import * as types from './mutation-types'

const state = {
  paymentMethods: [],
  paymentIntent: {},
  account: {},
  accountOwners: [],
  accountRepresentative: {},
  membershipFee: {},
  setupIntent: {},
  payments: [],
  latestPayment: {},
  revenueProjection: {},
  refunds: [],
  stripeAccount: {},
}
const mutations = {
  [types.PAYMENTS_CREATE_ACCOUNT](state, data) {
    state.account = data
  },
  [types.PAYMENTS_SET_ACCOUNT](state, data) {
    state.account = data
  },
  [types.PAYMENTS_SET_PAYMENT_METHODS](state, data) {
    state.paymentMethods = data.data
  },
  [types.PAYMENTS_ADD_PAYMENT_METHOD](state, data) {
    let paymentMethods= state.paymentMethods
    paymentMethods.push(data)
    state.paymentMethods = paymentMethods
  },
  [types.PAYMENTS_SET_MEMBERSHIP_FEE](state, data) {
    state.membershipFee = data
  },
  [types.PAYMENTS_SET_SETUP_INTENT](state, data) {
    state.setupIntent = data
  },
  [types.PAYMENTS_SET_PAYMENTS](state, data) {
    state.payments = data
  },
  [types.PAYMENTS_SET_LATEST_PAYMENT](state, data) {
    state.latestPayment = data
  },

  [types.PAYMENTS_SET_REVENUE_PROJECTION](state, data) {
    state.revenueProjection = data
  },
  [types.PAYMENTS_SET_REFUNDS](state, data) {
    state.refunds = data
  },
  [types.PAYMENTS_SET_ACCOUNT_OWNERS](state, data) {
    state.accountOwners = data
  },
  [types.PAYMENTS_SET_ACCOUNT_REPRESENTATIVE](state, data) {
    state.accountRepresentative = data
  },
  [types.PAYMENTS_SET_STRIPE_ACCOUNT](state, data) {
    state.stripeAccount = data
  },
}


export default {
  state,
  mutations,
}